<template>
  <modal :title="title" @close="$emit('close')" :show-close-button="true" class="modal__warning">
    <p v-html="message"></p>
    <template v-slot:footer>
      <button class="btn btn-cancel modal__button" @click="$emit('close')">Continue</button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/utils/Modal';

export default {
  name: 'info-about-plan-modal',
  components: {
    Modal,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    message: {
      required: true,
      type: String,
    },
  },
};
</script>
